import { createBrowserRouter, RouteObject, useRoutes } from 'react-router-dom';
import { routes as moduleRoutes } from '@spendbrain/modules';

const routes: RouteObject[] = [...moduleRoutes];

const Routes = () => {
  const children = useRoutes(routes);

  return children;
};

export default Routes;

export const routerInstance = createBrowserRouter(routes);
